// FILE: pages/Home/Hero.jsx  (or wherever your Hero lives)
import styles from "../../styles/pages/home/Hero.module.scss";
import { useContact } from "../../components/Contacts/ContactModals";
import { createFormspreeSubmitter } from "../../components/Contacts/contactSubmitters";




export default function Hero() {
  const NAME = "Technology for Public Good";

  const submitter = createFormspreeSubmitter("https://formspree.io/f/mojjblba");
  //Use ONE contact hook (don’t create two different ones)
  const { openSheet, openCard, openCalendly, Modal } = useContact(submitter);

  return (
    <section className={styles.section}>
      {/* BG */}
      <div className={styles.background} aria-hidden="true">
        <div className={styles.gradientGlow} />
        <div className={styles.gridMask}>
          <div className={styles.gridPattern} />
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.twoColGrid}>
          <div>
            <span className={styles.chip}>Open to speaking & collaborations</span>

            <h1 className={styles.title}>
              {/* <span className={styles.name}>{NAME}</span> */}
              <h1 className={styles.heroTitle}>
                 <span className={styles.name}>{NAME}</span>
                  </h1>
              <span className={styles.tagline}>Research. Policy. Solutions.</span>
            </h1>

            <p className={styles.paragraph}>
              I’m Muntaza, and I work across technology, business, and research to strengthen institutions, expand access, and scale community solutions.
            </p>

            <div className={styles.ctaRow}>
              <button
                type="button"
                // onClick={() => openCard("conversation")}
                // onClick={() => openCard(openCalendly)}

                onClick={openCalendly}
                className={`${styles.btn} ${styles.btnLight}`}
                aria-label="Book a conversation"
              >
                Book a conversation
              </button>

              <button
                type="button"
                onClick={() => openCard("speaking")}
                className={`${styles.btn} ${styles.btnPrimary}`}
                aria-label="Invite me to speak"
              >
                Invite me to speak
              </button>

              <button
                type="button"
                onClick={openSheet}
                className={`${styles.btn} ${styles.btnOutline}`}
                aria-label="Choose a way to work together"
              >
                Ways to work together
              </button>

              <a
                href="https://thewaterproject.org/"
                className={`${styles.btn} ${styles.btnOutline}`}
                aria-label="Support a cause"
                target="_blank"
                rel="noreferrer noopener"
              >
                Support a cause
              </a>
            </div>

            <ul className={styles.badgesList}>
              <li className={styles.badge}><span className={styles.dotIndigo} />Google Techmakers Ambassador</li>
              <li className={styles.badge}><span className={styles.dotFuchsia} />Hack for LA</li>
              <li className={styles.badge}><span className={styles.dotTeal} />UN Collaborator</li>
            </ul>
          </div>

          {/* Right: Globe Map */}
          <div className={styles.portraitCol}>
            <div className={styles.mapWrap} role="img" aria-label="Global map with focus on the Global South">
              <svg viewBox="0 0 400 400" className={styles.globe}>
                <defs>
                  <radialGradient id="shade" cx="50%" cy="45%">
                    <stop offset="0%" stopColor="rgba(255,255,255,0.18)" />
                    <stop offset="70%" stopColor="rgba(255,255,255,0.06)" />
                    <stop offset="100%" stopColor="rgba(255,255,255,0.02)" />
                  </radialGradient>
                </defs>

                <circle cx="200" cy="200" r="180" fill="url(#shade)" className={styles.sphere} />

                <ellipse cx="200" cy="200" rx="170" ry="12" className={styles.gridLine}/>
                <ellipse cx="200" cy="200" rx="150" ry="45" className={styles.gridLine}/>
                <ellipse cx="200" cy="200" rx="110" ry="85" className={styles.gridLine}/>
                <ellipse cx="200" cy="200" rx="60" ry="120" className={styles.gridLine}/>

                <ellipse cx="200" cy="200" rx="175" ry="70" transform="rotate(90 200 200)" className={styles.gridLine}/>
                <ellipse cx="200" cy="200" rx="170" ry="60" transform="rotate(60 200 200)" className={styles.gridLine}/>
                <ellipse cx="200" cy="200" rx="170" ry="60" transform="rotate(120 200 200)" className={styles.gridLine}/>

                <path d="M110 260 Q200 180 290 230" className={styles.arc} />
                <path d="M240 240 Q320 170 340 250" className={styles.arc} />
                <path d="M150 280 Q210 230 300 260" className={styles.arc} />

                <circle cx="140" cy="260" r="4" className={`${styles.node} ${styles.nodeFuchsia}`} />
                <circle cx="230" cy="235" r="4" className={`${styles.node} ${styles.nodeIndigo}`} />
                <circle cx="300" cy="245" r="4" className={`${styles.node} ${styles.nodeTeal}`} />
                <circle cx="335" cy="260" r="4" className={`${styles.node} ${styles.nodeTeal}`} />
              </svg>
            </div>
            <div className={styles.halo} aria-hidden="true" />
          </div>
        </div>
      </div>
      {/*Render modal ONCE */}
      <Modal />
    </section>
  );
}
